import React from 'react'

function LoadingSpinner({ size = 'md', className = '', text }) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="flex flex-col items-center space-y-2">
        <div 
          className={`loading-spinner border-2 ${sizeClasses[size]}`}
          style={{ borderTopColor: 'transparent' }}
        />
        {text && (
          <span className="text-sm text-muted-foreground">{text}</span>
        )}
      </div>
    </div>
  )
}

export default LoadingSpinner